module.exports = __webpack_public_path__ + "img/vuejs.6dbf580a.svg";